import React from "react";
import "./Event_Modal.css";
import { Modal } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Event_card from "../../in_company/event/event_section/event_card/Event_card";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Event_Modal({ data, IMG_URL, ...props }) {
  // 🔹 Event Card Data Array
  const eventData = [
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
      cardHeading: "Mittal Group at Shotshow 2023",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
      cardHeading: "Mittal Group at Shotshow 2023",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
      cardHeading: "Mittal Group at Shotshow 2023",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
      cardHeading: "Mittal Group at Shotshow 2023",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
      cardHeading: "Mittal Group at Shotshow 2023",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
      cardHeading: "Mittal Group at Shotshow 2023",
    },
  ];

  const eventAllImgData = [
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
    },
  ];
  return (
    <>
      <section className="Event_Modal_hodler common_modal_holder">
        <Modal
          {...props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="Event_Modal common_modal"
        >
          <Modal.Body>
            <div className="close_icon_holder" onClick={props.onHide}>
              <FontAwesomeIcon className="close_icon" icon={faCircleXmark} />
            </div>
            <div className="swiper_cards_holder">
              <Swiper
                spaceBetween={0}
                slidesPerView={1}
                modules={[Navigation]}
                navigation
                className="Event_modal_swiper common_swiper"
              >
                {data?.event_images?.map((item, index) => (
                  <SwiperSlide key={index}>
                    <Event_card
                      imgSrc={IMG_URL + item.image}
                      cardHeading={data.name}
                      status={true}
                    />

                    <div className="event_Details_holder">
                      <h5>{data?.sub_name}</h5>
                      <p>{data?.description}</p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            <div className="swiper_all_img_holder">
              <Swiper
                spaceBetween={20}
                slidesPerView={4}
                className="eventAllImg_swiper"
              >
                {data?.event_images?.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="img_holder">
                      <img
                        src={IMG_URL + item?.image}
                        alt="event"
                        className="eventAllImg"
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
}

export default Event_Modal;
